import React from "react";
import logo from "../images/logo.png";

export default function User() {
  return (
    <div className="User">
      <div className="logo">
        <img src={logo} alt="logo" />
      </div>
      <div className="info">
        <p>todoX</p>
        <a>logout</a>
        {/* <p>logout</p> */}
      </div>
    </div>
  );
}
